module.exports = __webpack_public_path__ + "img/map-pin.4f14efc4.svg";